'use strict';
import { getDataFromArgs, getOptionsFromArgs, makeURLInterpolator, stringifyRequestData, } from "./utils";
function getRequestOptions(self, requestArgs, spec, overrideData) {
    const commandPath = makeURLInterpolator(spec.path || '');
    const requestMethod = (spec.method || 'GET').toUpperCase();
    const urlParams = spec.urlParams || [];
    const encode = spec.encode || ((data) => data);
    const host = spec.host;
    const path = self.createResourcePathWithSymbols(spec.path);
    const args = [].slice.call(requestArgs);
    const urlData = urlParams.reduce((urlData, param) => {
        const arg = args.shift();
        if (typeof arg !== 'string') {
            throw new Error(`Lalamove: Argument "${param}" must be a string, but got: ${arg} (on API request to \`${requestMethod} ${path}\`)`);
        }
        urlData[param] = arg;
        return urlData;
    }, {});
    const dataFromArgs = getDataFromArgs(args);
    const data = encode(Object.assign({}, dataFromArgs, overrideData));
    const options = getOptionsFromArgs(args);
    if (args.filter((x) => x != null).length) {
        throw new Error(`Lalamove: Unknown arguments (${args}). Did you mean to pass an options object? (on API request to ${requestMethod} \`${path}\`)`);
    }
    const requestPath = self.createFullPath(commandPath, urlData);
    const headers = Object.assign(options.headers, spec.headers);
    if (spec.validator)
        spec.validator(data, { headers });
    const dataInQuery = spec.method === 'GET' || spec.method === 'DELETE';
    const bodyData = dataInQuery ? {} : data;
    const queryData = dataInQuery ? data : {};
    return {
        requestMethod,
        requestPath,
        bodyData,
        queryData,
        headers,
        host,
        settings: options.settings,
    };
}
function makeRequest(self, requestArgs, spec, overrideData) {
    return new Promise((resolve, reject) => {
        let options;
        try {
            options = getRequestOptions(self, requestArgs, spec, overrideData);
        }
        catch (err) {
            reject(err);
            return;
        }
        function requestCallback(err, response) {
            if (err) {
                reject(err);
            }
            else {
                resolve(spec.transformResponseData
                    ? spec.transformResponseData(response)
                    : response);
            }
        }
        const emptyQuery = Object.keys(options.queryData).length === 0;
        const path = [
            options.requestPath,
            emptyQuery ? '' : '?',
            stringifyRequestData(options.queryData),
        ].join('');
        const { headers, settings } = options;
        self.request(options.requestMethod, path, options.bodyData, { headers, settings }, requestCallback);
    });
}
export default makeRequest;
//# sourceMappingURL=makeRequest.js.map